import { EmployeeAssignTableDataDto } from '@interfaces/models';
import { Typography, ColumnDef } from '@ui/components';
import { formatPhoneNumber } from '@helpers/utils';
import { Checkbox } from '@ui/components';
import { TFunction } from 'i18next';

export const getEmployeesCreateColumns = (
  t: TFunction,
): ColumnDef<EmployeeAssignTableDataDto>[] => [
  {
    id: 'select',
    size: 40,
    maxSize: 40,
    header: ({ table }) => (
      <Checkbox
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
        checked={table.getIsAllRowsSelected()}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        checked={row.getIsSelected()}
        className="ml-0.5"
      />
    ),
  },
  {
    accessorKey: 'name',
    maxSize: 300,
    header: () => t('EMPLOYEE_PROFILES.EMPLOYEES_ASSIGN.NAME_SURNAME'),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {`${row.original.firstName} ${row.original.lastName}`}
      </Typography>
    ),
  },
  {
    accessorKey: 'phoneNumber',
    maxSize: 300,
    header: () => t('EMPLOYEE_PROFILES.EMPLOYEES_ASSIGN.PHONE_NUMBER'),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {formatPhoneNumber(row.original.phoneNumber, row.original.phoneExt)}
      </Typography>
    ),
  },
];
